import { cn } from "@/lib/utils";
import { Progress } from "@/components/ui/progress";
import { useTranslation } from "react-i18next";
import type { ChatProgress as ChatProgressType } from "@/hooks/useAgentChat";

interface ChatProgressBarProps {
  progress: ChatProgressType | null;
  status: string;
  className?: string;
}

export function ChatProgressBar({ progress, status, className }: ChatProgressBarProps) {
  const { t } = useTranslation();

  if (!progress) return null;

  const isCompleted = status === "completed";

  return (
    <div className={cn("space-y-1.5", className)}>
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>
          {t("inspectionChat.progress.items", {
            answered: progress.answered,
            total: progress.total,
          })}
        </span>
        <span
          className={cn(
            "font-mono font-medium tabular-nums",
            isCompleted && "text-emerald-600 dark:text-emerald-400",
          )}
        >
          {progress.percentage}%
        </span>
      </div>
      <Progress
        value={progress.percentage}
        className={cn("h-1.5", isCompleted && "[&>div]:bg-emerald-500")}
      />
    </div>
  );
}
